import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// ====================================================================
// ziven-theme-aura v0.2.8 buildElements.js
// ====================================================================
//
// 共享 DOM 创建函数 (mobile drawer + desktop sidebar 复用)
// - buildUserBlock: 居中堆叠 头像+badge+名字+等级
// - buildStatsSection: 5 stats 横向 5 等分
// - buildNavSection: 6 nav (5 主体 + 1 separator + 4 账号) + 1 separator
//                   ziven-theme-aura 自己的 nav 容器, 不再 extend HeaderPrimary.items()
//                   (「后台管理」那一行**只在移动端抽屉**里加, 桌面侧边栏不加 —— 见
//                    addAccountNavItems + isDrawerNavContainer 的注释)
//
// v0.2.5: 标记当前路径所属的 nav item (左侧 4px solid 蓝灰条, 跟 ziven.ski 1:1 复刻)
// v0.2.5a: m.route.get() 优先 (跟 vendor LinkButton.isActive 1:1)
// v0.2.5b:
//   1. 后台 admin 配 defaultRoute = "/tags" 时, / 上 标签 nav active
//      (Flarum 2.0 app.routes.tags.path = "/", / 跟 /tags 都走同一个 IndexPage,
//       实际 m.route.get() === "/", 跟 nav href="/tags" 不匹配, 需要 special case)
//      修复: vendor ForumApplication.tsx 实际用 attribute('defaultRoute') (camelCase), 不是派活 spec 写的 'default_route' (snake_case)
//   2. 头像 + badges 改 vendor 原生 (跟 ziven-ski 1:1 视觉)
//      - Avatar-container (vendor class, 走 vendor 自带 .Avatar-container 样式)
//      - Avatar 走 vendor 组件 (addChunkModule chunk 170 异步注册, lazy load 后能用)
//      - badges 走 vendor listItems(user.badges().toArray()) 跟 ziven-ski 1:1
//      - 删自建 Badge--group--1/5 逻辑 (ziven-ski 1:1 不需要)
//   3. SPA 跳 /u/Ziven / /settings console 报错 防御性修 (详见 modifyDrawer.js + modifySidebar.js)
//      - 删 injectMobileSidebar() 末尾 m.redraw() (强制 sync redraw 跟 vendor 路由 redraw scheduler 死锁 / 重复)
//      - refreshNavActive() 用 setTimeout(0) 延后到 microtask (跟 vendor mithril 路由 redraw 错开, 避免在 vendor redraw 中替换 DOM 触发错误)
//      - refreshNavActive() try/catch 包 replaceWith (防御性, 实际 throw console.error 可见, 不污染 stack)
//
// v0.2.12 (2026-10-24, 辉哥拍板 A 方案 = 末位): 游客态 (未登录) 的移动端抽屉里
//   **也显示「外观」行**, 位置 = 主体 nav 之后 = **末位** (全部讨论 → 标签 → 外观).
//   - 游客分支 priority = **-5** (负值 ⇒ 排在「标签」**实际生效 70** 之后 ⇒ 末位);
//     登录态 priority **保持 25 不变** ⇒ 登录态抽屉 nav 的 li 序列**逐项零变化**.
//   - 账号组其它行 (分隔线 / 个人主页 / 设置 / 后台管理 / 退出登录) 仍**只在登录态**.
//   - `if (inDrawer)` 门保留 ⇒ 桌面端 aura 侧边栏不出现这一行.
//   - 游客态**不发起任何需要登录的 API 请求** (配色写 sessionStorage, 见 appearanceSwitcher.js).
//
// v0.2.13 (2026-10-24, 辉哥拍板 A 方案): **游客态桌面端也显示 aura 侧边栏**
//   - 「外观」行的门从「仅抽屉」放宽成「**抽屉 或 游客态桌面侧栏**」:
//     游客态: 抽屉 ✅ + 桌面侧栏 ✅ (priority 仍 -5 ⇒ 末位)
//     登录态: 抽屉 ✅ (priority 仍 25) / 桌面侧栏 ⛔ 不加 ⇒ **登录态桌面侧栏 DOM 零变化**.
//   - 新增 isDesktopSidebarNavContainer(container): 判「这个 nav 容器是不是桌面侧边栏里的那个」
//     (祖先 .App-sidebar-aura; 游离时退回视口判据 min-width: 992px) —— 与 isDrawerNavContainer 严格互补.
//   - ⚠️ 「标签」的实际生效 priority = **70** (aura 用 setPriority('tags', 70) 覆盖了
//     flarum-tags 原生的 -10) ⇒ 游客态可见行 = 全部讨论(100) / 标签(70) / 外观(-5) ⇒ 外观在末位.
//
// 5 stats 写死占位 (辉哥 v6 拍板):
//   - 主题 4 / 积分 5 / 粉丝 0 / 关注 0 / 获赞 0
//   - 等级 1 写死
//   - TODO 注释: 装 follow/likes/points/level 扩展后改读真实数据
//
// kFormat 函数保留: 装扩展后大数自动 k 格式化 (3000→3k, 12580→12.5k)
//
// v0.2.0 改动: nav item 从 extend HeaderPrimary.items() 改为 ziven-theme-aura 自己的容器
//   - 桌面端 vendor top bar (Flarum 2.0 在 .App-drawer 内部, 跟 ziven.ski 1.8 不一样)
//   - 之前 v0.1.0c 桌面端会跟 vendor top bar 重复, 现在 nav 走 sidebar 自己的容器
//   - 跟 ziven.ski 真实 1:1 (ziven.ski sidebar 8 nav 跟 vendor top bar 不冲突)
//
// v0.2.5 标记当前路由 active 状态 (辉哥 16:04 反馈, 跟 ziven.ski 真实 1:1):
//   - ziven.ski 1.8 真实 (Playwright 调研): 当前路由对应 nav item 加 .active class
//     实际 li.border-left 从 `4px solid rgba(0, 0, 0, 0)` (透明) 变 `4px solid rgb(162, 165, 185)` (浅灰)
//   - ziven-theme-aura 实施: nav item 路径匹配时加 .active class
//     CSS: `.App-drawer-aura-nav .nav-item.active { border-left: 4px solid var(--aura-text-2); padding-left: 8px }`
//     默认 `.nav-item { border-left: 4px solid transparent; padding-left: 8px }` (占位避免 layout shift)
//   - 路径匹配规则: 精确匹配, 跟 ziven.ski 真实一致 (ziven.ski vendor ItemList.add 默认行为)
//   - 当前路径: window.location.pathname (Flarum 2.0 mithril 路由下跟 m.route.get() 一致, 但更稳定)
//
// v0.2.5b 头像 + badges 改 vendor 原生 (辉哥 18:32 反馈, 跟 ziven-ski-theme 1:1 视觉):
//   - ziven-ski-theme Sidebar.js L52-56 真实实现:
//     <div className="Avatar-container">
//       {avatar(user)}                  // vendor helper (vendor 2.0 实际未注册, mithril m() 接受 falsy 不 throw)
//       <ul className="badges">{listItems(user.badges().toArray())}</ul>
//     </div>
//   - ziven-theme-aura 实施 (改 vendor Avatar 组件代替 vendor avatar helper):
//     - 原因: vendor 2.0 dist grep 0 个 "common/helpers/avatar" 注册 (同步 add 没, addChunkModule 也没),
//       ziven-ski 1:1 follow 实际 Avatar 容器是空 div (vendor 没注册 helper, mithril 接受 undefined child 不 throw 但不渲染)
//     - 改用 vendor `flarum/common/components/Avatar` 组件 (addChunkModule chunk 170 异步注册, lazy load 后可用),
//       实际能渲染 .Avatar DOM, 跟 ziven-ski 设计意图一致 (vendor 原生 Avatar + vendor 原生 .badges)
//   - 验证: visual 上 Avatar 跟 ziven-ski Avatar 像素级一致 (都用 vendor Avatar 组件)
// ====================================================================

import app from 'flarum/common/app';
import Avatar from 'flarum/common/components/Avatar';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LinkButton from 'flarum/common/components/LinkButton';
import listItems from 'flarum/common/helpers/listItems';
import extractText from 'flarum/common/utils/extractText';
import { buildAppearanceNavItem } from './appearanceSwitcher';
// mithril 是 vendor 注入的 window.m free variable, 不 import (跟 modifyDrawer.js m.redraw() 一致)
// 跟 ziven-ski 1:1 pattern: ziven-ski 源码 Sidebar.js 也用 free variable m (m.mount(o, J))

// v0.2.6 改读真实数据 (辉哥 20:25 反馈, 装 3 扩展后改)
//  - 主题: 暂时写死 (user.discussionCount() 等 likes 扩展装)
//  - 积分: 读 user.attribute('money') (antoinefr/flarum-ext-money v2.0.0-rc.1)
//  - 粉丝: 读 user.attribute('followerCount') (ianm/follow-users 2.0.0-beta.7, camelCase 不是 snake_case)
//  - 关注: 读 user.attribute('followingCount') (ianm/follow-users 2.0.0-beta.7, camelCase 不是 snake_case)
//  - 获赞: 暂时写死 (等 likes 扩展)
// SOP 126 教训: vendor Flarum 2.0 attribute key camelCase 不是 snake_case, 派活前必查 vendor 实际 key
const STATS = [{
  name: '主题',
  value: user => user.discussionCount() || 0
}, {
  name: '积分',
  value: user => parseFloat(user.attribute('money') || 0)
}, {
  name: '粉丝',
  value: user => parseInt(user.attribute('followerCount') || 0, 10)
}, {
  name: '关注',
  value: user => parseInt(user.attribute('followingCount') || 0, 10)
}, {
  name: '获赞',
  value: 0
}];
const LEVEL = 1;
const kFormat = n => n < 1000 ? "".concat(n) : n < 10000 ? "".concat((n / 1000).toFixed(1), "k") : "".concat(Math.round(n / 1000), "k");

// === 创建 user-block DOM (不注入, 只创建) ===
// v0.2.5b: 头像 + badges 改 vendor 原生 (跟 ziven-ski 1:1)
//   - Avatar-container (vendor class) 走 vendor 自带样式
//   - 头像用 vendor Avatar 组件 (vendor 2.0 异步 chunk 170 注册, 实际能用)
//   - badges 走 vendor listItems(user.badges().toArray()) (vendor 原生 ul.badges 样式)
//   - mithril m.render 模式: 渲染 mithril vnode 树到 real DOM 占位 div
//     不挂 mithril main app mount point, 不会被 mithril redraw 误清
export function buildUserBlock(user) {
  const userBlock = document.createElement('div');
  userBlock.className = 'App-drawer-aura-user-block';

  // 1.1 Avatar 容器 (vendor Avatar-container class, 走 vendor 自带样式)
  // ziven-ski 1:1: <div className="Avatar-container">{avatar}<ul className="badges">{listItems}</ul></div>
  const avatarWrap = document.createElement('div');
  avatarWrap.className = 'Avatar-container';
  // mithril 渲染 vendor Avatar 组件 + vendor ul.badges
  m.render(avatarWrap, [m(Avatar, {
    user
  }), m('ul', {
    className: 'badges'
  }, listItems(user.badges().toArray()))]);
  userBlock.appendChild(avatarWrap);

  // 1.2 用户名 h4
  const name = document.createElement('div');
  name.className = 'App-drawer-aura-name';
  name.textContent = user.displayName();
  userBlock.appendChild(name);

  // 1.3 等级 (写死 1)
  const level = document.createElement('div');
  level.className = 'App-drawer-aura-level';
  level.innerHTML = "\u7B49\u7EA7 <span class=\"num\">".concat(LEVEL, "</span>");
  userBlock.appendChild(level);
  return userBlock;
}

// === 创建 5 stats DOM (不注入, 只创建) ===
// v0.2.6: 接受 user 参数, 5 stats 中 1-4 项用函数形式读 user.attribute (装 3 扩展后)
//  - 主题: user.discussionCount() (vendor Flarum 原生)
//  - 积分: user.attribute('money') (antoinefr/flarum-ext-money v2.0.0-rc.1)
//  - 粉丝: user.attribute('followerCount') (ianm/follow-users 2.0.0-beta.7, camelCase)
//  - 关注: user.attribute('followingCount') (ianm/follow-users 2.0.0-beta.7, camelCase)
//  - 获赞: 写死 0 (等 likes 扩展装后再改 user.attribute('likesReceived'))
export function buildStatsSection(user) {
  const statsSection = document.createElement('div');
  statsSection.className = 'App-drawer-aura-stats';
  STATS.forEach(stat => {
    const cell = document.createElement('div');
    cell.className = 'stat-cell';
    const num = document.createElement('div');
    num.className = 'stat-num';
    // value 可能是函数 (user => ...) 或写死数字 (e.g. 获赞 0)
    const rawValue = typeof stat.value === 'function' ? stat.value(user) : stat.value;
    num.textContent = kFormat(rawValue);
    cell.appendChild(num);
    const label = document.createElement('div');
    label.className = 'stat-label';
    label.textContent = stat.name;
    cell.appendChild(label);
    statsSection.appendChild(cell);
  });
  return statsSection;
}

// === 创建 nav section (走 vendor IndexSidebar.navItems() + 路由切换时 m.render 重画) ===
// v0.2.8 (辉哥 08:50 拍板 A 方案): 走 ziven-ski 1:1 模式
//   - 主体 nav (全部主题 / 标签 / 我的关注 / etc) 走 vendor `IndexSidebar.prototype.navItems()`
//     这样装 fof-bookmarks / 任何扩展自动加 nav, 不用改 ziven-theme-aura
//   - 账号 nav (个人主页 / 设置 / 退出) ziven-theme-aura 自己加, 跟 ziven-ski Sidebar.js L108-198 sessionItems() 1:1
//   - active 状态走 vendor LinkButton.isActive 1:1 (m.route.get() 跟 href 比对)
//   - 跟 ziven-ski 1:1 一样, 接受 v0.2.5b 的 defaultRoute special case 失效
// v0.2.5 旧实现 (active 4px 蓝灰条) 已删, 改用 vendor LinkButton 自动 active
// v0.2.5b 旧实现 (defaultRoute special case) 已删, 跟 ziven-ski 1:1 接受 admin 配首页 active 不 work
// 实施: 用 mithril m.render() + 路由切换监听手动重画
//   - m.render: 一次性渲染, vendor LinkButton.isActive 一次算完写入 DOM attribute (active="true")
//   - 路由切换: ziven-theme-aura 监听 mithril 路由变化 (跟 v0.2.5b 一样的 monkey-patch pushState 机制)
//     重新 m.render 触发 LinkButton 重新 initAttrs, active attribute 重写
//   - 实际 v0.2.5b 一样机制, 只是 buildNavSection 内容改成 vendor navItems
export function buildNavSection() {
  const navSection = document.createElement('div');
  navSection.className = 'App-drawer-aura-nav';
  renderNavItems(navSection);
  return navSection;
}

// === nav 选中态判定 (纯函数, 无副作用, 可单测) ===
//
// v0.2.21 (2026-10-27, 辉哥 03:5x 报障): 父项在子路径上不再掉选中态.
//   报障原话: 「sidebar里面，我发现比如"教务系统"，当路径是/scheduler时，"教务系统"是选中状态，
//              但当路径是/scheduler/cards时，sidebar中"教务系统"就不是选中状态」
//
// 根因 (见 CHANGELOG v0.2.21 段): renderNavItems() 里给所有 LinkButton 类 nav 项**强制覆盖**
//   active, 判定是 `path?.split('?')[0] === item.attrs.href?.split('?')[0]` = **严格相等**
//   ⇒ 当前路径是 /scheduler/cards 时, /scheduler/cards ≠ /scheduler ⇒ 父项掉选中态.
//   (core LinkButton.isActive 同为严格相等 —— 那是 core 的语义, 但 aura 的 override 决定最终表现.)
//
// 修法: 命中条件 = `cur === target` **或** `cur.startsWith(target + '/')` —— 按**路径段**判.
//   ⇒ 「教务系统」(href = /scheduler) 在 /scheduler/cards 等子路由上保持选中.
//
// ⛔ 为什么**不能**用宽松的 `cur.startsWith(target)` (不补斜杠):
//   本仓有**近名路由** —— nav 项「全部话题」href = `/topics`, 而单个话题详情页是 `/topic/:name`
//   (只差一个 s) ⇒ 宽松前缀会让**每个话题详情页都误亮「全部话题」**.
//   同理 `/scheduler` 不能命中 `/scheduler-foo` / `/schedulerx/cards`.
//   ⇒ 必须在 target 后面补一个 '/' —— **按路径段**判, 不是按字符串前缀.
//
// ⚠️ target === '/' (根路径) 时:
//   `target + '/'` = '//' ⇒ 永远不会匹配任何 cur ⇒ **只有精确命中 '/' 才算命中**
//   ⇒ 这**不是漏特判**, 是**有意**的: 根路径不该点亮任何子路径 nav 项.
//
// 归一化 (两侧都做):
//   1. 去掉 `#hash` (片段) —— 同一页面的不同锚点仍是同一个 nav 项
//   2. 去掉 `?query` —— 同上 (core 的 isActive 也是 split('?')[0])
//   3. 去掉**尾部** '/' —— `/scheduler/` 与 `/scheduler` 等价
//      (根路径 '/' **保留不删** —— 删了就变成空串)
//   4. 传入的是**完整 URL** (含 '://') 时取其 pathname —— **防御性**:
//      currentPath 的来源是 `history.pushState` 的
//      `args[2] || m.route.get() || window.location.pathname` (见 modifySidebar.js / modifyDrawer.js),
//      args[2] **可能**是完整 URL ⇒ 形态**不保证唯一** ⇒ 不能假设传进来的一定是路径.
//
// 空值防御: 任一侧为空 / 非字符串 ⇒ 返回 false (不让 undefined 参与比较).
export function isNavItemActive(currentPath, href) {
  if (!currentPath || typeof currentPath !== 'string') return false;
  if (!href || typeof href !== 'string') return false;
  const cur = normalizeNavPath(currentPath);
  const target = normalizeNavPath(href);
  if (!cur || !target) return false;

  // 1. 精确命中
  if (cur === target) return true;

  // 2. 子路径命中 (按路径段) —— ⛔ 必须是 target + '/', 不是 target
  //    (target === '/' 时 '//' 永不匹配 ⇒ 根路径只精确命中, 见上)
  return cur.startsWith(target + '/');
}

// nav 路径归一化 (私有 helper, 只给 isNavItemActive 用)
//   ⚠️ 与上面的命中判定**严格配套**: 归一化去掉尾部 '/' 之后, 两侧都成 `/scheduler` 这种形态,
//      子路径判定才能用 `target + '/'` 稳定命中.
function normalizeNavPath(value) {
  if (!value || typeof value !== 'string') return '';
  let path = value.trim();
  if (!path) return '';

  // 1. 完整 URL ⇒ 只取 pathname (防御性, 见上)
  if (path.indexOf('://') !== -1) {
    try {
      path = new URL(path).pathname;
    } catch (e) {
      // URL 解析失败 ⇒ 手工剥掉 scheme + host, 至少不把整条 URL 当路径
      path = path.replace(/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\/[^/]*/, '');
    }
  }

  // 2. 去掉 #hash
  const hashIdx = path.indexOf('#');
  if (hashIdx !== -1) path = path.slice(0, hashIdx);

  // 3. 去掉 ?query
  const queryIdx = path.indexOf('?');
  if (queryIdx !== -1) path = path.slice(0, queryIdx);
  if (!path) return '';

  // 4. 去掉尾部 '/' (根路径 '/' 保留不删)
  if (path.length > 1 && path.charAt(path.length - 1) === '/') {
    path = path.replace(/\/+$/, '');
  }
  return path;
}

// 实际渲染 nav items 到容器, 可被外部 (refreshNavActive) 重复调用
// v0.2.8 修 (重要, SOP 133 候选): 不用 m.route.get() 缓存, 主动传入 currentPath
//   - 之前用 m.render(ul, listItems(navItems.toArray())) 渲染, vendor LinkButton.initAttrs
//     在 mithril 0.2.x 异步路由切换期间调用, m.route.get() 返回旧值
//   - 修法: renderNavItems 接受 currentPath 参数, 在 vendor LinkButton 上覆盖 active 属性
//     `m(LinkButton, { href, active: currentPath === href, ... })` 强制覆盖
//   - 验证: 4 路由 (m.route.set 后) active 全部正确
// v0.2.8 hotfix3 修 (重要, 辉哥 10:45 反馈): 改 vendor "tags" priority
//   - vendor flarum-tags extend(IndexSidebar.navItems) 加 item-tags priority -10
//   - priority 最低, 排最后 (跟账号 nav 后面)
//   - 辉哥要 "标签" 跟其他 5 主体 nav 同一区域, 不要掉到底部
//   - 修法: 拿 items 后, 找到 itemName === 'tags' (vendor flarum-tags 加的), 改 priority 为 70
//     排在我的 aura-separator (50) 之前, 跟 5 主体同一区域
//   - ziven-ski 1.8 era 顺序: 全部讨论 / 消息 / Bookmarks / 我的关注 / 标签 (5 主体在同一区域)
export function renderNavItems(container, currentPath) {
  // 1. 拿 vendor + 各扩展加的 nav items (默认 IndexSidebar 只有 allDiscussions, fof-bookmarks 加 Bookmarks)
  const sidebar = new IndexSidebar();
  const navItems = sidebar.navItems();

  // 1.5 v0.2.8 hotfix3: 改 vendor "tags" priority, 排到 5 主体同一区域
  // vendor flarum-tags addTagList L14-21 add 'tags' priority -10 (最低)
  // 我们改成 70 (在 5 主体 100/90/89/? 之后, separator 50 之前)
  // (跟 ziven-ski 1.8 era 顺序一致)
  // 防御: 如果 vendor flarum-tags 没装, 'tags' key 不存在, setPriority 会 throw error (ItemList L121)
  if (navItems.has('tags')) {
    navItems.setPriority('tags', 70);
  }

  // 1.6 去掉 flarum-tags 加的 <Separator /> (渲染成 <li class="Dropdown-separator">)
  // 谁加的: vendor flarum-tags addTagList.js L24 `items.add('separator', <Separator />, -12)`
  //         (core Separator.js 渲染成 <li className="Dropdown-separator" />)
  // 为什么多余: 它 priority -12, 排在「退出登录」(10) 之后、tag 明细 (item-tagN) 之前,
  //         而 tag 明细在 aura LESS 里是 `> ul > li[class^="item-tag"] { display: none }` 全隐藏
  //         => 只剩一条孤零零挂在 nav 最底部的分隔线 (borderBottom 1px), 视觉多余.
  // 作用域安全: aura 用的是 `new IndexSidebar()` 的独立实例 + 独立 ItemList,
  //         删掉只影响 aura 自己的 nav, 不影响 vendor IndexPage 侧边栏, 也不影响
  //         flarum-tags 页面上的分隔线.
  // 防御: vendor flarum-tags 没装 / 改 key 名时, 'separator' 不存在, remove 是 no-op.
  // 注: aura 自己的两个 separator (item-aura-separator / App-drawer-aura-nav-separator) 保留不动.
  if (navItems.has('separator')) {
    navItems.remove('separator');
  }

  // 2. 追加 ziven-theme-aura 自己的账号 nav + 1 separator (跟 ziven-ski sessionItems() 1:1)
  //    账号 nav 里的「后台管理」那一行**只在移动端抽屉**里加, 桌面侧边栏不加
  //    => 容器判定 (isDrawerNavContainer): 这个 nav 容器是不是抽屉里的那个
  //    v0.2.13: 再加一个判据 (isDesktopSidebarNavContainer): 是不是桌面侧边栏里的那个
  //    refreshNav: 回调 = 用**同一个容器**重画这段 nav (切换配色后要重画, 见 appearanceSwitcher.js 注释)
  addAccountNavItems(navItems, isDrawerNavContainer(container), isDesktopSidebarNavContainer(container), () => renderNavItems(container, currentPath));

  // 1.8 v0.2.11: 1.8 1:1 复刻 1.8 ziven.ski 未登录 sidebar (辉哥 18:38 反馈 C 方案)
  // 1.8 ziven.ski 实际未登录只显示 '全部讨论' + '标签' 2 nav, 4 tag 详细 (item-tag1/2/4/5) 不渲染
  // vendor flarum-tags addTagList L44 itemName = 'tag' + tag.id() (geek.ski tags id 1/2/4/5: 滑雪技术分享/装备测评/单板/双板)
  if (!app.session.user) {
    ['tag1', 'tag2', 'tag4', 'tag5'].forEach(key => navItems.remove(key));
  }

  // 3. mithril m.render 渲染 vendor LinkButton 列表到 <ul>
  // 跟 buildUserBlock L104-107 一样 m.render 模式 (不走 mithril mount)
  // v0.2.8 修: currentPath 优先 m.route.get() 兜底
  const path = currentPath || m.route.get();
  console.log('[ziven-theme-aura] renderNavItems called, currentPath=', path, 'items=', navItems.toArray().length);
  container.innerHTML = ''; // 清空旧 DOM
  const ul = document.createElement('ul');
  container.appendChild(ul);

  // v0.2.8 修: 给 vendor LinkButton 强制覆盖 active
  // vendor LinkButton.initAttrs 看 attrs.active 有值就用, 没值才用 m.route.get()
  // 主动传 active: 强制 active 正确
  // v0.2.21 (2026-10-27, 辉哥 03:5x 报障): 判定从**严格相等**换成 isNavItemActive()
  //   - 改前: `path?.split('?')[0] === item.attrs.href?.split('?')[0]` ⇒ /scheduler/cards ≠ /scheduler
  //           ⇒ 父项「教务系统」在子路由上掉选中态
  //   - 改后: 按**路径段**前缀命中 (精确命中 或 cur.startsWith(target + '/'))
  //           ⇒ 父项在子路径上保持选中; ⛔ 仍**不**用宽松 startsWith(target)
  //              (否则 /topic/:name 会误亮「全部话题」/topics —— 见 isNavItemActive 注释)
  // v0.2.8 修 (重要): 给 m(LinkButton, ...) 加 key (ItemList itemName, 跟 vendor listItems 行为一致)
  //   - mithril 0.2.x 限制: fragment 里的 vnode 要么都有 key 要么都没, 不然报错
  //   - vendor listItems L84-90 加 key = itemName, 我们手动 m(LinkButton) 也得加
  //   - key 用 itemName (e.g. 'allDiscussions', 'aura-profile', 'fof-bookmarks')
  const navArray = navItems.toArray();
  const itemsWithActive = navArray.map(item => {
    // item 是 mithril vnode, attrs 在 item.attrs, tag 在 item.tag
    // itemName 存在 item.itemName (ItemList.add 第二个参数 metadata)
    // 只处理 LinkButton (e.g. item-aura-profile, item-allDiscussions, item-fof-bookmarks)
    if (item && item.tag && item.tag === LinkButton && item.attrs && item.attrs.href) {
      return m(LinkButton, _objectSpread(_objectSpread({
        key: item.itemName || item.attrs.key
      }, item.attrs), {}, {
        active: isNavItemActive(path, item.attrs.href)
      }), item.children);
    }
    return item;
  });
  m.render(ul, listItems(itemsWithActive));
}

// === 容器判定: 这个 nav 容器是不是**移动端抽屉**里的那个? ===
//
// 背景: addAccountNavItems 是抽屉 nav + 桌面侧边栏**共用**的
//   (modifyDrawer.js 的 injectMobileSidebar 和 modifySidebar.js 的 injectDesktopSidebar
//    都调 buildNavSection() => renderNavItems() => addAccountNavItems()),
//   所以"是不是登录用户"分不出两边. 「后台管理」那一行只能加在抽屉这边.
//
// 判据 (两级, 两边结论一致):
//   1. 容器**已经挂进 DOM** 时 (路由重绘 refreshNavActive 走的就是这条路):
//      直接看祖先 —— 在 #drawer 里 => 抽屉; 在 .App-sidebar-aura 里 => 桌面侧边栏.
//      这是**真正的容器判定**.
//   2. 容器**还是游离的**时 (首次 build: buildNavSection() 先 render, 调用方随后才把它
//      插进 DOM): 祖先查不到 => 退回视口判据 (max-width: 991.98px).
//      这跟两个调用方自己的守卫**完全等价**:
//        - modifyDrawer.js:  `if (window.matchMedia('(min-width: 992px)').matches) return;`
//          => 只在 < 992px 往抽屉里注入
//        - modifySidebar.js: `if (!window.matchMedia('(min-width: 992px)').matches) { ...remove...; return; }`
//          => 只在 >= 992px 往侧边栏里注入
//      两条路互斥且覆盖全区间 => 首次 build 的结论跟后续重绘**一致**,
//      不会出现"先加上、路由一变又消失"的闪烁.
//   3. 视口跨区间切换时 modifyDrawer.js 会把 aura 注入的元素整个删掉再重建
//      => 不会留下跨区间的脏状态.
//
// 为什么不用纯视口判据: 视口只是**间接**信号, 容器才是事实.
// 为什么不用纯容器判据: 首次 build 时容器还没插进 DOM, 纯容器判据会漏掉第一次渲染.
function isDrawerNavContainer(container) {
  if (!container) return false;

  // 1. 容器已挂进 DOM: 看祖先 (真容器判定)
  if (container.isConnected) {
    if (container.closest('#drawer')) return true;
    if (container.closest('.App-sidebar-aura')) return false;
  }

  // 2. 首次 build (容器游离): 退回视口判据 (跟调用方的守卫等价)
  return window.matchMedia('(max-width: 991.98px)').matches;
}

// === 容器判定: 这个 nav 容器是不是**桌面端 aura 侧边栏**里的那个? ===
//
// v0.2.13 (2026-10-24, 辉哥拍板 A 方案): 游客态桌面侧栏也要有「外观」行
//   ⇒ addAccountNavItems 需要**第三个**判据: 「是不是桌面侧栏」.
//
// 与 isDrawerNavContainer **严格互补** (同一套两级判据, 同一份祖先/视口口径):
//   1. 容器**已挂进 DOM**: 看祖先 —— 在 .App-sidebar-aura 里 => 桌面侧边栏;
//      在 #drawer 里 => 抽屉 (不是桌面侧边栏).
//      (桌面侧边栏的 nav 容器 = .App-sidebar-aura 里的 .App-drawer-aura-nav,
//       抽屉的 = #drawer 里的同名容器 —— 两者 class 相同, 只能靠祖先区分.)
//   2. 容器**还是游离的** (首次 build: buildNavSection() 先 render, 调用方随后才把它
//      插进 DOM): 祖先查不到 => 退回视口判据 (min-width: 992px).
//      这跟 modifySidebar.js 的守卫 `if (!window.matchMedia('(min-width: 992px)').matches) {...return;}`
//      **完全等价** ⇒ 首次 build 的结论跟后续重绘一致.
//
// ⚠️ 为什么不能只靠视口判据: 视口只是**间接**信号, 容器才是事实.
// ⚠️ 为什么不能只靠容器判据: 首次 build 时容器还没插进 DOM, 纯容器判据会漏掉第一次渲染.
function isDesktopSidebarNavContainer(container) {
  if (!container) return false;

  // 1. 容器已挂进 DOM: 看祖先 (真容器判定)
  if (container.isConnected) {
    if (container.closest('.App-sidebar-aura')) return true;
    if (container.closest('#drawer')) return false;
  }

  // 2. 首次 build (容器游离): 退回视口判据 (跟 modifySidebar.js 的守卫等价)
  return window.matchMedia('(min-width: 992px)').matches;
}

// === 追加账号 nav + 1 separator 到 vendor navItems (跟 ziven-ski sessionItems() 1:1) ===
// 主体 5 nav 走 vendor, 这些账号 nav ziven-theme-aura 自己管
// inDrawer: 这个 nav 容器是不是**移动端抽屉**里的那个 (见 isDrawerNavContainer 注释).
//   只有抽屉才加「后台管理」那一行 (桌面侧边栏不加, 见下面那段注释).
// inDesktopSidebar: 这个 nav 容器是不是**桌面端 aura 侧边栏**里的那个
//   (见 isDesktopSidebarNavContainer 注释).
//   **只有游客态**用它放宽「外观」行的门 (v0.2.13) ⇒ 登录态桌面侧栏零变化.
// refreshNav: 回调 = 用同一个容器重画这段 nav.
//   「外观」行切换配色后要重画 (nav 是独立 mithril root, m.redraw() 画不到它) —— 见 appearanceSwitcher.js.
//
// v0.2.12 (2026-10-24, 辉哥拍板 A 方案 = 末位): **游客态 (未登录) 也显示「外观」行**
//   改前: 函数开头 `if (!user) return;` ⇒ 账号组整体不出现 ⇒ 「外观」行**只在登录态**出现.
//   改后: 游客分支**只加「外观」这一行**(priority -5 ⇒ 末位),
//         其余账号行 (分隔线 / 个人主页 / 设置 / 后台管理 / 退出登录) 仍然**只在登录态**
//         —— 它们全在这个 return 之后, 一行没动.
//   ⛔ **登录态代码路径一字未改** ⇒ 登录态抽屉 nav 的 li 序列 (顺序 + 数量) 逐项零变化.
//
// v0.2.13 (2026-10-24, 辉哥拍板 A 方案): **游客态桌面端也显示 aura 侧边栏**
//   「外观」行的门从「仅抽屉」放宽成「**抽屉 或 游客态桌面侧栏**」:
//     游客态 (!user): 抽屉 ✅ + 桌面侧栏 ✅  (priority 仍 -5 ⇒ 末位)
//     登录态 (user)  : 抽屉 ✅ (priority 仍 25) / 桌面侧栏 ⛔ 不加 (桌面顶栏已有
//                      core 的 ThemeSwitcher, 加了是重复入口) ⇒ **桌面侧栏 DOM 零变化**.
//   ⇒ 登录态桌面侧栏那一行 `if (inDrawer)` **一字未改**, 仍是唯一的登录态入口门.
//
// priority 口径 (core ItemList.toArray() = items.sort((a, b) => b.priority - a.priority),
//   降序 + ES2019 稳定排序 ⇒ **位置只由 priority 决定**;
//   代码把 items.add() 插在哪一行, 只在 priority **相同**时才影响先后):
//   登录态 25  → 排在「账号设置」(30) 之后、「后台管理」(25) 之前 (同优先级先 add ⇒ 稳定排序在前)
//   游客态 -5  → 负值 ⇒ 排在「标签」**之后** = **末位** (A 方案)
//   ⚠️「标签」的**实际生效** priority = **70** (不是 flarum-tags 原生的 -10):
//      aura 自己在 renderNavItems 里 `navItems.setPriority('tags', 70)` 覆盖过
//      (生产 forum.js 字节级原文: n.has("tags")&&n.setPriority("tags",70))
//   ⚠️ **覆盖作用域**: aura 用的是 `new IndexSidebar()` 的**独立实例** + **独立 ItemList**
//      ⇒ 这条 `setPriority('tags', 70)` 只作用于 **aura 自己的 nav**,
//        ⛔ **不作用于 core 的 `IndexPage` 侧边栏** —— core 那条链仍是**原生值**:
//          全部讨论(100) → 外观(25) → 标签(-10) → separator(-12) → tag 明细(-14) → moreTags(-16)
//      ⇒ 下面「可见行 / 末位」的推演, 只对 **aura 自己的 nav** 成立.
//   ⚠️ **为什么碰不到 core 的侧边栏 (extend / setPriority 的适用域机制, 2026-10-24 补)**:
//      - core `IndexSidebar.tsx` 的 `navItems()` **每次调用都 `new ItemList()`**, extend 链跑在**本次调用的临时对象**上;
//        flarum-tags 用 `extend(IndexSidebar.prototype,'navItems',...)` 加 'tags' (priority 写死 **-10**) ⇒ **每次调用都重跑**
//      - aura 的 `renderNavItems()` = `new IndexSidebar()` + `sidebar.navItems()` = **aura 自己的一次独立调用**
//        ⇒ 拿到**本次调用专属的临时 ItemList** ⇒ `setPriority('tags',70)` **只活到 aura 那次渲染**
//      - core 的 `IndexPage` 侧边栏渲染 `<IndexSidebar />` ⇒ 其 view 里 `this.navItems().toArray()` = **另一次调用**
//        ⇒ 另一个临时 ItemList ⇒ extend 链重跑 ⇒ 'tags' 仍是 **-10** ⇒ aura 那次 setPriority **根本碰不到它**
//      ⇒ 通用口径: 「某包把 priority 改成 X」**只对「该包自己持有并渲染的那个容器」生效**;
//        判某项 priority **必须先确定是哪个容器**; 临时实例上的 setPriority **只活到那次渲染**
//   ⚠️「不可见」有**三种机制**, 别混成一谈:
//      ① 根本不渲染 (压根没 add 进 ItemList)
//      ② 被 `ItemList.remove(key)` **移除** ⇒ **不在链上**, 不参与排序
//      ③ DOM 在, 但被 CSS `display: none` **藏** ⇒ **仍在链上**, 仍参与排序 (priority 照算)
//   ⇒ 判「谁在末位」要看**可见行**的 priority 序, **不是**链上的最低值.
//   ⇒ 游客态**可见**行 = 全部讨论(100) / 标签(70) / 外观(-5)
//     (tag 明细 + moreTags 都是**机制③** (CSS 藏): 仍在 ItemList 里参与排序, 只是不可见)
//     ⇒ 外观就在**末位**, 阈值只需 **< 70** (**不需要** < -16).
//   ⇒ 选 -5 不选更小的负数: -5 高于**所有已知负值项**
//     (flarum-tags 的 tag 明细 -14 / moreTags -16 都是**机制③** ⇒ 仍占链上的负值;
//      而 flarum-tags 的 separator(-12) 是**机制②** —— 已被 aura 自己在 renderNavItems 里
//      `navItems.remove('separator')` **移除** ⇒ 不再参与排序, 不该再被列为「已知负值项」)
//   ⇒ -5 不会被它们插到「外观」前面.
//   ⚠️ **隐藏 tag 明细的 LESS 规则 (v0.2.13 注释订正, 勿再简写)**:
//      真实规则是**一条规则、四个选择器**, 且**宿主限定在 `.App-drawer-aura-nav` 内 (不是全局)**:
//        `.App-drawer-aura-nav>ul>li[class^="item-tag"],.App-drawer-aura-nav>ul>li[class^="item-moreTags"],.App-drawer-aura-nav>ul li.item-icon,.App-drawer-aura-nav>ul li.item-label{display:none}`
//      (生产 forum.css `076beed6` offset **747377** 原文)
//      ⚠️ **offset 是逐代漂移值**: 上面那个 **747377** 只对 `076beed6` 那一代成立 (`33a39b49` 代 = 747605, 当前代 `5bfbaa23` = **748003**) ⇒ **引用前必须现取**, 或**按上面那行原文定位** (原文稳定, 永不过期)
//      ⭐ **该规则是顶层规则, 不带 `@media` 条件 ⇒ 全端生效** (`less/forum.less` L350 `.App-drawer-aura-nav {` 起, 花括号深度 = 0, media 栈为空)
//      ⭐ **桌面端同样命中**: 桌面侧边栏的 nav 容器**也是** `.App-drawer-aura-nav` (见本文件 L345) ⇒ **不是**「桌面端无此宿主」
//      ⇒ 藏的是 4 样: tag 明细(item-tagN) / **moreTags** / item-icon / item-label;
//      ⇒ **moreTags 是被 CSS 藏** (**机制③**: 仍在 ItemList 里, priority **-16**, 只是不可见),
//        ⛔ **不是**被 `remove('moreTags')` 移除 —— 生产 forum.js 字节证据:
//          `setPriority("tags",70)` 命中 **1** / `remove("separator")` 命中 **1** / `remove("moreTags")` 命中 **0**
//          ⇒ moreTags **仍在 ItemList 里** (priority -16), 只是不可见.
//   ✅ **实测证据** (生产双引擎 390×844, chromium / webkit 逐位一致):
//      全部讨论 top=**122** / 标签 top=**169** / 外观 top=**216** / 单板 h=**0**
//      ⇒ 可见行确实只有那 3 行, 且「外观」确实落在**末位**.
//   ⛔ 别按「标签是 -10 / 0」推演「外观要 < -16」—— 那是按原生值算的错推演.
//   ✅ **订正 (2026-10-24 18:35, ziven-core 指出 / 本方认下)**: 上一句的「-10 / 0」是**反例** (提醒**别**按这两个值去推演), **不是**本包口径; 本包**唯一权威口径** = 「标签」**实际生效** priority = **70** (flarum-tags 原生 -10 → 本包 `setPriority('tags', 70)` 覆盖); 其中「0」这个数**出自我方 (aura) 旧口径** (本包 CHANGELOG 里「派活给的 priority 表里『标签 = 0（默认）』与实际不符」那条记载即为出处), **不是** ziven-core 从源码读到的 ⇒ ziven-core 的纠正是对的, 我方认下.
function addAccountNavItems(navItems, inDrawer, inDesktopSidebar, refreshNav) {
  const user = app.session.user;

  // 「外观」行的 priority: 登录态 25 (位置不变) / 游客态 -5 (末位, A 方案)
  const appearancePriority = user ? 25 : -5;

  // === 游客态 (未登录): 只加「外观」这一行 (末位) ===
  //   ⛔ 账号组的其它行 (分隔线 / 个人主页 / 设置 / 后台管理 / 退出登录) 仍然**只在登录态**
  //      —— 它们全在这个 return 之后, 一行没动.
  //   v0.2.13: 门从「仅抽屉」放宽成「抽屉 **或 桌面侧栏**」⇒ 游客态桌面端也有这一行.
  //   游客态这一行**不发起任何需要登录的 API 请求**:
  //     appearanceSwitcher.selectScheme() 游客分支写 sessionStorage
  //     (core Application.initColorScheme 开局读它) ⇒ 游客切完配色刷新不丢.
  if (!user) {
    if (inDrawer || inDesktopSidebar) {
      navItems.add('aura-appearance', buildAppearanceNavItem(refreshNav), appearancePriority);
    }
    return;
  }

  // separator (在 vendor nav 跟账号 nav 之间, 跟 ziven-ski 1.8 sessionItems L113 separator 1:1)
  navItems.add('aura-separator', m('li', {
    className: 'App-drawer-aura-nav-separator'
  }), 50);

  // 个人主页 (跟 ziven-ski sessionItems L116-125 1:1)
  navItems.add('aura-profile', m(LinkButton, {
    icon: 'fas fa-user',
    href: app.route('user', {
      username: user.username()
    })
  }, app.translator.trans('core.forum.header.profile_button')), 40);

  // 设置 (跟 ziven-ski sessionItems L128-136 1:1)
  navItems.add('aura-settings', m(LinkButton, {
    icon: 'fas fa-cog',
    href: app.route('settings')
  }, app.translator.trans('core.forum.header.settings_button')), 30);

  // === 「外观」 (主题选择器) — 辉哥 2026-10-23 23:22 拍板方案 A ===
  //
  // 行长什么样 (方案 A): 整行可点 = 左边一个主题图标 + 中间「外观」 + 右边显示当前模式文字;
  //   点开 = core 原生底部抽屉 (core @phone 下 .Dropdown-menu 变 position:fixed 底部面板).
  //   组件实现见 ./appearanceSwitcher.js (自己写小组件, 复用 core SelectDropdown + Button + Icon,
  //   选项列表自己收窄到 3 项: 跟随系统 / 浅色 / 深色).
  //
  // 为什么**登录态只加在抽屉里** (inDrawer 门, 跟「后台管理」同一道门):
  //   - 辉哥的需求是「给**移动端抽屉**加一行」;
  //   - 桌面端 (>= 992px) 顶栏**本来就有** core 自己的主题选择器
  //     (core ThemeSwitcher, 挂 HeaderSecondary.items() priority 12,
  //      显隐 = app.allowUserColorScheme && app.forum.attribute('showThemeSelector'));
  //   - 而 aura 自己的**桌面侧边栏** (.App-sidebar-aura, >= 992px 是**可见的**,
  //     只有 <= 991.98px 才被 LESS 藏掉) 渲染的是**同一套**账号 nav
  //     ⇒ 不加这道门的话, 桌面侧边栏会凭空多出一行「外观」⇒ 违反「桌面端不受影响」;
  //   - 加了门: 桌面端 (侧边栏 + 顶栏) **零变化**.
  //   ⛔ **v0.2.13 这道门对登录态一字未改** ⇒ 登录态桌面侧栏 DOM 零变化.
  //
  // priority 25 (登录态): 排在「设置」(30) **之后**.
  //   跟「后台管理」(25) 同优先级, 但**先 add** ⇒ ItemList.toArray() 的 sort 是**稳定排序**
  //   (同优先级保持 add 顺序) ⇒ 实际顺序: 个人主页(40) → 设置(30) → **外观(25)** → 后台管理(25) → 退出登录(10)
  //   ⇒ 「外观」紧贴「设置」正下方 (辉哥验收口径).
  //
  // 未登录态 (游客): 上面那个 `if (!user) { ... return; }` 分支里**单独加这一行**,
  //   priority = -5 ⇒ 落在主体 nav 之后 = **末位** (A 方案) ⇒ 游客抽屉里是:
  //   全部讨论 → 标签 → **外观** .
  //   v0.2.13: 游客态**桌面侧栏**也是同一套 (门 = inDrawer || inDesktopSidebar).
  //   ⛔ 其它账号行 (分隔线 / 个人主页 / 设置 / 后台管理 / 退出登录) 游客态**不出现**.
  if (inDrawer) {
    navItems.add('aura-appearance', buildAppearanceNavItem(refreshNav), appearancePriority);
  }

  // === 「后台管理」 (只加在**移动端抽屉**里, 且只给管理员) ===
  //
  // 为什么要有这一行:
  //   vendor .Header-secondary 那一行 (含 ziven-core 注入的后台按钮 li.item-settingIcon)
  //   在移动端 (<= 991.98px) 被 aura 的 less **整块** display:none 藏掉了
  //   (less/forum.less 的「移动端抽屉: 整块隐藏 vendor .Header-secondary 那一行」段)
  //   => 手机上进不去后台. 桌面端 (>= 992px) 不藏, 顶栏一直有那个扳手.
  //
  // 做法: 不去动 vendor 那一行 (整块藏 = 抽屉顶干净 + 抽屉里不做搜索, 是产品决策),
  //   而是在**我们自己画的抽屉 nav** 里加一行「后台管理」, 点击时**委托**去点那个被藏起来的
  //   vendor 按钮 (.item-settingIcon button) —— vendor 那个按钮自己会弹 adminPanelModal.
  //   ⇒ 功能入口换位置, 不改 vendor 那一行的显隐.
  //
  // 只在抽屉里加 (桌面侧边栏不加):
  //   - addAccountNavItems 是抽屉 nav + 桌面侧边栏**共用**的 (两个调用方都调 buildNavSection)
  //     => 桌面侧边栏会多出这一行, 但桌面顶栏本来就有那个扳手, 侧边栏这行是**重复入口**.
  //   - ziven-ski 1.8 时代侧边栏**确实有**这一行 (priority 20, icon fa-wrench,
  //     href=adminUrl, target=_blank), 但**当前 ziven-ski 已把它整段注释掉**
  //     (packages/ziven-ski-theme/js/src/forum/components/Sidebar.js L139-156 是 /* ... */)
  //     ⇒ 当前生态**故意不显示** (桌面顶栏有扳手, 侧边栏这行冗余).
  //   ⇒ 桌面侧边栏保持改前状态 (跟 1.8 现状一致), 抽屉才有这一行.
  //
  // 权限判据 (后端下发, 前端只读): app.forum.attribute('adminUrl')
  //   - vendor ziven-core 注入那个扳手时用的就是它:
  //     packages/ziven-core /js/src/forum/modifyHeaderSecondary.js L33
  //       `if (!app.session.user || !app.forum.attribute('adminUrl')) return;`
  //   - ForumResource 只在 $actor->can('administrate') 时才下发 adminUrl
  //     ⇒ 它本身就是「是不是管理员」的判据, 前端**不自造**管理员判定.
  //   - 没权限就**整行不渲染** (连 <a> 都不渲染), 不给一行点不动的死链接
  //     (辉哥产品偏好: 没权限就不给入口).
  //   - 顺带保证「委托点击」一定能找到目标按钮: 非管理员压根没有 .item-settingIcon.
  //
  // 用 LinkButton 不用 Button: aura 的 LESS 是 `> ul > li > a` 直接子选择器,
  //   换成 <button> 会丢掉 `> a` 的图标间距/label 颜色/字体, 导航行会走形.
  // 不给 href (跟「退出登录」一样): 点了不跳转, 只委托 click.
  //   (vendor m.route.Link 会先调我们的 onclick, 我们 preventDefault 之后它就不跳了.)
  // 文案用 vendor 同一个 key: core.forum.header.admin_button => 「后台管理」.
  //   (vendor/flarum-lang/chinese-simplified/locale/core.yml L546 的中文就是「后台管理」;
  //    不新增 locale key, 也不在 aura 这边另造文案.)
  // 找不到 vendor 按钮时**静默不动**: 不抛错、不 console.error (找不到不是错误状态).
  //
  // ⚠️ 委托点击的**顺序**: 先关抽屉, 再点 vendor 扳手 (抄 Flarum 原生写法, 别反).
  //   原生出处: vendor/flarum/core/js/src/common/components/AbstractGlobalSearch.tsx L121-124
  //     app.drawer.hide();
  //     setTimeout(() => openSearchModal(), 150);
  //   ① 为什么必须**先 hide 再 click** (顺序不能反):
  //      缺陷现象 (实机 iPhone 390×844 实测): 手机上点抽屉里的「后台管理」, 后台面板弹出来了,
  //      **抽屉却还开着** ⇒ 抽屉那一层 (浅色面板 + 「后台管理」「退出登录」两行) 留在画面上,
  //      它本身是被 modal 压住的, 但 modal 内容是**半透明**的 ⇒ 那两行从半透明内容里**透出来**
  //      ⇒ 看起来就是「那两行字浮在后台面板上」,
  //      而且 iframe 的下边缘 (CSS y=562) 正好把「后台管理」那行切掉一半.
  //      实测层级 (同一页面、同一次测量, 改后复测一致):
  //        .App-drawer        z-index = 1050  (position: fixed, 宽 270)
  //        .ModalManager      z-index = 1050  (与抽屉 z-index **数值相同** ⇒ 谁压谁由
  //                                           **层叠上下文 / 祖先顺序**决定: .ModalManager 在
  //                                           DIV#modal 里, 抽屉在 DIV#app 里, 而 #modal 在
  //                                           body 里排在 #app **之后** ⇒ .ModalManager 叠在
  //                                           抽屉**之上** ⇒ ⇒ ⇒ **抽屉那层不是盖在 modal 上,
  //                                           而是被 modal 压住、只从半透明的 modal 内容里透出来**)
  //        .AdminPanelModal   z-index = 2     (这是 ModalManager **内部**的对话框层级 ——
  //                                           两者不在同一个层叠上下文, ⛔ 别拿它跟抽屉比大小)
  //        .Modal-content     background = rgba(255,255,255,0.15)  ← **半透明** ⇒ 抽屉透得出来
  //        #adminPanelIframe  只占 CSS y 49..562 ⇒ 562 以下 modal 里是空的, 抽屉从那里透上来
  //      ⇒ 根因 = 「**抽屉没关**」, ⛔ **不是 z-index 配错** (调 z-index 只会把整块抽屉
  //        压到 modal 上面, 更糟; 也不要动 iframe 高度 —— 那是 ziven-core 的事).
  //      ⇒ 顺序不能反: 若先 click 再 hide, modal 已经弹出、抽屉还在屏幕上 (滑出动画 ~150ms),
  //        这段时间里上面那个重叠窗口**照样存在**;
  //        先 hide ⇒ 抽屉先滑出画面; 再 click ⇒ modal 弹出时画面上已经没有抽屉的东西
  //        ⇒ 重叠窗口从根上消失 (不是靠调 z-index 硬压).
  //   ② 为什么是 setTimeout(..., 150):
  //      抄 Flarum 原生 (AbstractGlobalSearch.tsx L123). 抽屉滑出是**CSS 过渡动画**,
  //      原生注释原文: "Hiding it here rather than in `openSearchModal` lets the drawer
  //      finish sliding out during the delay below." ⇒ 150ms 是等这段动画走完再弹 modal.
  //   ③ ⛔ 与本文件下面「退出登录」那条约束**不冲突**, 别混为一谈:
  //      那条约束是「**window.confirm() 绝对不包 setTimeout**」—— confirm() 必须在用户
  //      手势事件的**同步上下文**里调用, 延后到宏任务会丢掉 gesture 上下文, 移动端
  //      (iOS Safari / Android Chrome) 可能不弹框或直接返回 false.
  //      本项**根本不调 confirm()** ⇒ 这里 setTimeout 延后的是一次**合成 click**
  //      (不是弹框), 两条规则各有各的适用域, 这里**没有**违反那条约束.
  if (inDrawer && app.forum.attribute('adminUrl')) {
    navItems.add('aura-admin', m(LinkButton, {
      icon: 'fas fa-wrench',
      onclick: e => {
        e.preventDefault();
        const btn = document.querySelector('#drawer .item-settingIcon button') || document.querySelector('.item-settingIcon button');
        if (!btn) return; // 找不到 vendor 按钮: 静默不动 (同改前)
        app.drawer.hide(); // 先关抽屉: 抽屉没关 ⇒ 它那层会从半透明 modal 里透出来 (它本就被 modal 压住)
        setTimeout(() => btn.click(), 150); // 等抽屉滑出动画结束, 再弹 adminPanelModal
      }
    }, app.translator.trans('core.forum.header.admin_button')), 25);
  }

  // 退出 (跟 ziven-ski sessionItems L158-168 1:1)
  // 用 LinkButton 不用 Button: aura 的 LESS 是 `> ul > li > a` 直接子选择器,
  // 换成 <button> 会丢掉 `> a` (图标间距/label 颜色/字体) 全部样式, 导航行会走形.
  // 确认框用浏览器原生 window.confirm(): 辉哥实机试了 Flarum 原生 Modal 方案,
  // 反馈"效果不太好", 改回浏览器原生. 写法跟 Flarum 核心同款
  // (vendor forum/utils/PostControls.js L169).
  //   - confirm() 绝对不包 setTimeout: window.confirm() 必须在用户手势事件的
  //     同步上下文里调用, 延后到宏任务会丢掉 gesture 上下文, 移动端浏览器
  //     (iOS Safari / Android Chrome) 可能不弹框或直接返回 false.
  //     (app.modal.show() 需要 setTimeout 是 Flarum 官方要求, 规则相反, 别照搬.)
  //   - e.preventDefault() 留在同步部分: 它拦的是 vendor m.route.Link 对
  //     <a href=""> 的默认跳转, 少了它会先跳走再弹框.
  //   - extractText(): trans() 返回的可能是 vdom 数组, 要抽纯文本给 confirm.
  navItems.add('aura-logout', m(LinkButton, {
    icon: 'fas fa-sign-out-alt',
    onclick: e => {
      e.preventDefault();
      if (confirm(extractText(app.translator.trans('ziiven-theme-aura.forum.logout_confirm_message')))) {
        app.session.logout();
      }
    }
  }, app.translator.trans('core.forum.header.log_out_button')), 10);
}